var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGem(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M507.874 196.406L403.874 42.562C399.405 35.953 391.968 32 383.999 32H127.999C120.03 32 112.593 35.953 108.124 42.562L4.126 196.406C-2.187 205.703 -1.155 218.125 6.532 226.297L238.53 472.453C243.061 477.266 249.374 480 255.999 480S268.936 477.266 273.468 472.453L505.468 226.297C513.155 218.125 514.186 205.703 507.874 196.406ZM382.462 96.588L446.96 192H306.854L382.462 96.588ZM255.999 178.891L177.64 80H334.358L255.999 178.891ZM129.536 96.588L205.143 192H65.04L129.536 96.588ZM255.999 421.016L85.417 240H426.583L255.999 421.016Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGem);
export default __webpack_public_path__ + "static/media/gem.e59d0c16a80229ddb6f392ee2c8da66a.svg";
export { ForwardRef as ReactComponent };